<div fxLayout="row" fxLayoutAlign="start center">
  <mat-icon *ngIf="svgIcon" [svgIcon]="svgIcon"></mat-icon>

  <mat-icon *ngIf="icon">{{icon}}</mat-icon>

  <h1>{{title}}</h1>
</div>
